import { Button, message, Popconfirm, Table } from 'antd';
import React, { useEffect } from 'react';
import { RootState } from '../../../redux/store';
import { useDispatch, useSelector } from 'react-redux';

import ProtectedLayout from '../../../layouts/ProtectedLayout';
import { DeleteOutlined } from '@ant-design/icons';
import ExportExcel from '../Shared/ExportExcel';
import { columnMappings } from '../Shared/utility';
import { deleteAllContactForms, deleteContactForm, listContactForms } from '../../../redux/actions/contactForm';

const ContactFormPage: React.FC = () => {
    const { contactForms, loading } = useSelector((state: RootState) => state.contactForm);
    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(listContactForms());
    }, [dispatch]);

    const handleDelete = async (id: string) => {
        try {
            await dispatch(deleteContactForm(id));
            message.success('İletişim formu kaydı başarıyla silindi');
        } catch (error) {
            message.error('Silme işlemi sırasında bir hata oluştu');
        }
    };

    const handleDeleteAll = async () => {
        try {
            await dispatch(deleteAllContactForms());
            message.success('Tüm iletişim formu kayıtları başarıyla silindi');
        } catch (error) {
            message.error('Silme işlemi sırasında bir hata oluştu');
        }
    };

    const columns = [
        {
            title: 'Adı',
            dataIndex: 'name',
        },
        {
            title: 'Email',
            dataIndex: 'email',
        },
        {
            title: 'Telefon',
            dataIndex: 'phone',
        },
        {
            title: 'Mesaj',
            dataIndex: 'message',
        },
        {
            title: 'İşlem Zamanı',
            dataIndex: 'createdAt',
            render: (text) => {
                return new Date(text).toLocaleString('tr-TR', {
                    year: 'numeric',
                    month: 'long',
                    day: 'numeric',
                    hour: '2-digit',
                    minute: '2-digit'
                });
            }
        },
        {
            title: 'İşlemler',
            key: 'actions',
            width: 100,
            render: (_, record) => (
                <Popconfirm title={`${record.name} Kaydı Silinecektir?`} onConfirm={() => handleDelete(record._id)} cancelText="İptal" okText="Evet">
                    <Button
                        danger
                        icon={<DeleteOutlined />}
                    >
                        Sil
                    </Button>
                </Popconfirm>
            ),
        },
    ];
    return (
        <ProtectedLayout>
            <h1 className="text-2xl font-bold">İletişim Formu Listesi</h1>
            <div className="space-y-4">
                <div className="flex justify-end">
                    <ExportExcel excelData={contactForms} fileName={"İletişim Formu Listesi"} columnMappings={columnMappings(columns)} />
                    <Button
                        danger
                        onClick={handleDeleteAll}
                        disabled={!contactForms?.length}
                    >
                        Tümünü Sil
                    </Button>
                </div>
                <Table
                    dataSource={contactForms || []}
                    columns={columns}
                    loading={loading}
                />
            </div>
        </ProtectedLayout>
    );
};

export default ContactFormPage;